import { useMutation, useQueryClient } from '@tanstack/react-query';
import { billingService, queryKeys } from '@/services';
import type { MarkPaidParams } from '@/services/billing/billing-service';

/**
 * Mark a statement paid (LR-556). On success, invalidate the whole
 * billing-statements branch (list + detail) so both refetch the paid row.
 * A 409 also invalidates: it means someone else already marked it paid, so
 * the cached draft row the user is looking at is stale.
 */
export const useMarkPaid = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, params }: { id: number; params: MarkPaidParams }) =>
      billingService.markPaid(id, params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.statements() });
    },
    onError: (error) => {
      const status = (error as { response?: { status?: number } })?.response?.status;
      if (status === 409) {
        queryClient.invalidateQueries({ queryKey: queryKeys.billing.statements() });
      }
    },
  });
};
